if (!customElements.get('quote-items')) {
  class QuotePage extends HTMLElement {
    constructor() {
      super();

      // options
      this.options = {
        currency: parseJson(this.dataset.options).currency,
        apiKey: parseJson(this.dataset.options).apiKey,
      };

      // elements
      this.form = this.querySelector('form');
      this.quoteItemsWrapper = this.querySelector('[data-quote-items-wrapper]');
      this.quotePlaceholdersWrapper = this.querySelector('[data-quote-placeholders-wrapper]');
      this.quoteSubtotalWrapper = this.querySelector('[data-quote-subtotal-wrapper]');
      this.quoteSubtotalPlaceholderWrapper = this.querySelector(
        '[data-quote-subtotal-placeholder-wrapper]'
      );
      this.audiogramForm = this.querySelector('audiogram-form');

      // quote items
      this.quoteItems = parseJson(localStorage.getItem('quote_cart')) || [];

      if (this.quoteItems.length > 0) {
        this.renderQuoteItems();
      } else {
        this.classList.add('quote-cart-is-empty');
      }

      // event listeners
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async renderQuoteItems() {
      for (const product of this.quoteItems) {
        let data = await fetch(
          `/products/${product.product.handle}?view=quote-product&variant=${product.variantId}`,
          {
            method: 'GET',
            headers: { 'Content-Type': 'text/html' },
          }
        );

        data = await data.text();
        let html = new DOMParser()
          .parseFromString(data, 'text/html')
          .querySelector('quote-item').outerHTML;

        // replace the fake variant placeholder with the actual variant or null if no variant, before inserting it into the dom
        html = html.replace('[fakeVariant]', product.fakeVariant);

        // put the html in the dom
        this.quoteItemsWrapper.insertAdjacentHTML('beforeend', html);
      }

      // check for audiogram
      if (this.audiogramForm) this.audiogramForm.checkAudiogram();

      // remove the placeholders
      this.quotePlaceholdersWrapper.classList.add('hidden');

      // update the subtotal
      this.updateSubtotal();

      // display the quote items
      this.quoteItemsWrapper.classList.remove('hidden');
    }

    /**
     * Update the quote subtotals
     */
    updateSubtotal() {
      const quoteItems = parseJson(localStorage.getItem('quote_cart')) || [];
      const formatter = new Intl.NumberFormat({
        style: 'currency',
        currency: this.options.currency,
      });

      let quoteSubtotal = this.quoteSubtotalWrapper.querySelector('[data-quote-subtotal]');

      let totalPrice = 0;

      quoteItems.forEach((quoteItem) => {
        quoteItem.product.variants.forEach((variant) => {
          if (variant.id === quoteItem.variantId) {
            totalPrice += (variant.price / 100) * quoteItem.quantity;
          }
        });
      });

      quoteSubtotal.textContent = formatter.format(totalPrice);

      // remove the placeholder
      this.quoteSubtotalPlaceholderWrapper?.classList.add('hidden');

      // display the subtotal
      this.quoteSubtotalWrapper.classList.remove('hidden');
    }

    /**
     * On submit handler
     */
    async onSubmitHandler(event) {
      event.preventDefault();
      const quoteItems = parseJson(localStorage.getItem('quote_cart'));

      let quoteLineItems = [];

      quoteItems.forEach((quoteItem) => {
        let includedProducts = {};

        this.querySelectorAll('quote-item').forEach((item) => {
          if (
            item.options.id === quoteItem.product.id &&
            item.options.variantId === quoteItem.variantId &&
            item.options.fakeVariant === quoteItem.fakeVariant
          ) {
            item.querySelectorAll('[data-included-product]').forEach((includedProduct, index) => {
              includedProducts[`Included product ${index + 1}`] = {
                key: `Included product ${index + 1}`,
                name: includedProduct.textContent,
              };
            });

            // add the fake variant if it exists
            const fakeVariant = item.options.fakeVariant;
            if (fakeVariant) {
              includedProducts[`Position`] = {
                key: `Position`,
                name: fakeVariant,
              };
            }

            // add the real variant name if it exists
            const variant = quoteItem.product.variants.find(
              (variant) => variant.id === quoteItem.variantId
            ).title;

            if (variant) {
              includedProducts[`Variant`] = {
                key: `Variant`,
                name: variant,
              };
            }
          }
        });

        quoteLineItems.push({
          product_id: quoteItem.product.id,
          name: quoteItem.product.title,
          vendor: quoteItem.product.vendor,
          variant_id: String(quoteItem.variantId),
          image: quoteItem.product.images[0],
          qty: quoteItem.quantity,
          product_url: `${Shopify.shop}/products/${quoteItem.product.handle}?variant=${quoteItem.variantId}`,
          price: quoteItem.product.variants.find((item) => item.id === quoteItem.variantId).price,
          options: includedProducts,
        });
      });

      let data = {
        shop: Shopify.shop,
        locale: Shopify.locale,
        api_secret: this.options.apiKey,

        quotes: quoteLineItems.map((item) => JSON.stringify(item)),
        additional_data: {
          name: this.form.querySelector('#quote-form-name').value || '',
          phone: this.form.querySelector('#quote-form-phone').value || '',
          email: this.form.querySelector('#quote-form-email').value || '',
          country: this.form.querySelector('#quote-form-country').value || '',
          message: this.form.querySelector('#quote-form-message').value || '',
          audiogramName: parseJson(localStorage.getItem('audiogram'))?.fileName || '',
          audiogramUrl: parseJson(localStorage.getItem('audiogram'))?.fileUrl || '',
          audiogramDate: parseJson(localStorage.getItem('audiogram'))?.fileDate || '',
        },
      };

      // add the loading state
      this.classList.add('loading');

      const response = await fetch('https://quote.globosoftware.net/app/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then((response) => {
        this.classList.add('quote-successful');
        // clear the quote cart
        this.querySelectorAll('quote-item').forEach((quoteItem) => {
          // remove the quote item from the DOM and local storage without checking the audiogram or updating the subtotal
          quoteItem.removeQuoteItem(false, false);
        });

        // remove the loading state
        this.classList.remove('loading');
      });
    }
  }

  window.QuotePage = QuotePage;
  customElements.define('quote-page', QuotePage);
}
